export const setTrending = (restaurants) => ({
    type: 'SET_TRENDING',
    restaurants
});